"use strict";

var _draftJs = require("draft-js");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = convertToEditorState;

function convertToEditorState(content) {
  if (!content) return _draftJs.EditorState.createEmpty();

  try {
    var contentState = (0, _draftJs.convertFromRaw)(content);
    return _draftJs.EditorState.createWithContent(contentState);
  } catch (e) {
    return _draftJs.EditorState.createEmpty();
  }
}